import { render, staticRenderFns } from "./cjsjReport.vue?vue&type=template&id=2ac02806&scoped=true&"
import script from "./cjsjReport.vue?vue&type=script&lang=ts&"
export * from "./cjsjReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac02806",
  null
  
)

export default component.exports